// DashboardPage.jsx
import { useEffect, useState } from 'react';
import { fetchDocumentTypes } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import AddDocumentModal from '../components/AddDocumentModal';
import { Menu, LogOut, Scan } from 'lucide-react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

const StatCard = ({ title, value }) => (
  <div className="bg-gradient-to-br from-blue-500 to-indigo-600 text-white p-6 rounded-2xl shadow-lg">
    <p className="text-sm font-medium opacity-80">{title}</p>
    <p className="text-4xl font-bold mt-2">{value}</p>
  </div>
);

function DashboardPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const org = localStorage.getItem('selected_organization');
    if (!org) {
      setError('Organisasi belum dipilih.');
      setLoading(false);
      return;
    }
    const { organization_id } = JSON.parse(org);
    setLoading(true);
    fetchDocumentTypes(organization_id)
      .then((data) => {
        setDocumentTypes(Array.isArray(data) ? data : data.data || []);
        setError('');
      })
      .catch((err) => {
        setError(err.message || 'Gagal memuat dokumen');
      })
      .finally(() => setLoading(false));
  }, []);

  const handleScan = () => {
    // langsung navigasi ke halaman scan
    navigate('/input-data/scan');
  };

  const handleLogout = () => {
    // contoh logout
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header dengan hamburger menu */}
      <header className="flex justify-between items-center p-4 bg-white shadow">
        <h1 className="text-xl font-bold text-gray-800">Dashboard</h1>
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button className="inline-flex items-center justify-center rounded-full p-2 hover:bg-gray-100 focus:outline-none">
              <Menu className="h-6 w-6" />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            align="end"
            className="bg-white rounded-md shadow-md p-1 w-48"
          >
            <DropdownMenu.Item
              onSelect={handleScan}
              className="flex items-center gap-2 px-2 py-2 cursor-pointer hover:bg-gray-100 rounded"
            >
              <Scan className="h-4 w-4" />
              <span>Scan</span>
            </DropdownMenu.Item>
            <DropdownMenu.Item
              onSelect={handleLogout}
              className="flex items-center gap-2 px-2 py-2 cursor-pointer hover:bg-gray-100 rounded"
            >
              <LogOut className="h-4 w-4" />
              <span>Log out</span>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </header>

      <main className="p-4 sm:p-6 lg:p-8">
        {/* Statistik */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <StatCard title="HARI INI" value="-" />
          <StatCard title="BULAN INI" value="-" />
          <StatCard title="TOTAL KESELURUHAN" value="-" />
        </div>

        {/* Daftar Jenis Dokumen */}
        <div className="mt-8">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-bold text-gray-800">Daftar Jenis Dokumen</h2>
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              + Tambah Jenis
            </button>
          </div>
          <div className="bg-white rounded-2xl shadow-sm divide-y divide-gray-100">
            {loading ? (
              <div className="p-4 text-gray-500">Memuat data...</div>
            ) : error ? (
              <div className="p-4 text-red-500">{error}</div>
            ) : documentTypes.length === 0 ? (
              <div className="p-4 text-gray-500">Belum ada jenis dokumen.</div>
            ) : (
              documentTypes.map((doc, index) => (
                <Link
                  key={doc.data_type_id || doc.name}
                  to={`/input-data/${(doc.nama_tipe || doc.name)?.toLowerCase().replace(' ', '-')}`}
                  state={{
                    data_type_id: doc.data_type_id,
                    expectation: doc.expectation,
                    nama_tipe: doc.nama_tipe || doc.name,
                  }}
                  className="flex items-center p-4 hover:bg-gray-50 transition-colors"
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold">
                    {index + 1}
                  </div>
                  <div className="ml-4 flex-grow">
                    <p className="font-semibold text-gray-800">{doc.nama_tipe || doc.name}</p>
                    <p className="text-sm text-gray-500">
                      {doc.total_entries || doc.count || 0} data tersedia
                    </p>
                  </div>
                </Link>
              ))
            )}
          </div>
        </div>
      </main>

      <AddDocumentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default DashboardPage;
